<template>
  <section class="form-list">
    <el-form
        ref="form"
        class="form form-extra-large"
        label-position="left"
        label-width="160px"
    >
      <el-form-item label="ID">{{ id }}</el-form-item>
      <el-form-item label="添加时间">{{ postData.add_time | timeToYmdHis }}</el-form-item>
      <el-form-item label="提交者">
        <v-avatar-nickname :value="postData.avatar" :nickname="postData.nickname"/>
      </el-form-item>
      <el-form-item label="错误码">{{ postData.errcode }}</el-form-item>
      <el-form-item label="错误消息">{{ postData.errmsg }}</el-form-item>
      <el-form-item label="消息 ID">{{ postData.msgid }}</el-form-item>
      <el-form-item label="无效用户">{{ postData.invaliduser }}</el-form-item>
      <el-form-item label="无效部门">{{ postData.invalidparty }}</el-form-item>
      <el-form-item label="无效标签">{{ postData.invalidtag }}</el-form-item>
      <el-form-item label="响应码">{{ postData.response_code }}</el-form-item>

      <el-form-item>
        <el-button @click="RouteConfig.errorWorkWeChatList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { getWorkWeChatDetails } from '@/api/error-log';

export default {
  name: RouteConfig.errorWorkWeChatDetail.name,
  data: () => ({
    RouteConfig,
    postData: {},
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    async show() {
      const { isError, data } = await getWorkWeChatDetails(this.id);
      if (isError || !data) return;
      this.postData = data;
    },
  },
};
</script>
